var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73346 7.23946V5.12709C4.73346 4.00662 5.18299 2.93204 5.98314 2.13974C6.7833 1.34745 7.86854 0.902344 9.00013 0.902344C10.1317 0.902344 11.217 1.34745 12.0171 2.13974C12.8173 2.93204 13.2668 4.00662 13.2668 5.12709V7.23946H15.4001C15.9659 7.23946 16.5085 7.46202 16.9086 7.85816C17.3087 8.25431 17.5335 8.7916 17.5335 9.35184V19.9137C17.5335 20.4739 17.3087 21.0112 16.9086 21.4074C16.5085 21.8035 15.9659 22.0261 15.4001 22.0261H2.60013C2.03433 22.0261 1.49171 21.8035 1.09164 21.4074C0.691558 21.0112 0.466797 20.4739 0.466797 19.9137V9.35184C0.466797 8.7916 0.691558 8.25431 1.09164 7.85816C1.49171 7.46202 2.03433 7.23946 2.60013 7.23946H4.73346ZM6.8668 5.12709V7.23946H11.1335V5.12709C11.1335 4.56685 10.9087 4.02956 10.5086 3.63342C10.1085 3.23727 9.56592 3.01472 9.00013 3.01472C8.43433 3.01472 7.89171 3.23727 7.49164 3.63342C7.09156 4.02956 6.8668 4.56685 6.8668 5.12709ZM2.60013 19.9137H15.4001V9.35184H2.60013V19.9137Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.1c6e6523fbb52c34bceb4dd0795baf9a.svg";
export { ForwardRef as ReactComponent };